import netcoServer from '../../apis/netcoServer';
import {GET_WORKFLOW_FILES_INFORMATION} from "../types";
import handleResponse from "../helpers/handleResponse";
import loadingCall from "../helpers/loadingCall";
import {fixSord} from "../../components/Helpers/utils";

const getWorkflowFilesInformation= (formData) => async (dispatch) => {
  // skip llega como índice de página base 0; el servicio espera un offset de registros
  const limit=formData.limit;
  if(limit)
    formData.skip=(formData.skip || 0) * limit;
  formData.sord=fixSord(formData.sord);
  let response = await loadingCall(dispatch, () => netcoServer.newPost('/UserService/getWorkflowFilesInformation', formData));
  handleResponse(dispatch, response, GET_WORKFLOW_FILES_INFORMATION, onSuccessPayload);
};

const onSuccessPayload = data => {
  return {
    workflowList: {
      entries: data.filesInfo.filesInfo,
      total:data.filesInfo.total
    }
  };
};
export default getWorkflowFilesInformation;